import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ChecklistSubmissionCreationFormWrapper } from 'src/Components/Forms/ChecklistSubmission/ChecklistSubmissionCreationFormWrapper';
import useFetchChecklist from 'src/Hooks/Queries/useFetchChecklist';

type ChecklistParams = {
  checklistId: string;
};

const SubmitChecklistDrawer = () => {
  const { t } = useTranslation();
  const { checklistId } = useParams<ChecklistParams>();
  const { data: checklist } = useFetchChecklist(checklistId);

  if (!checklistId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer
      title={checklist?.title ?? t('checklist.submitForm.submitChecklist', 'Remplir la checklist')}
    >
      {({ onClose }) => (
        <ChecklistSubmissionCreationFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          checklistId={checklistId}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default SubmitChecklistDrawer;
